var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading d-flex"},[_c('div',{staticClass:"loading-wrapper"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":70,"width":70}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }